import { ottActionFilter } from './models/ActionFilter';
import { Backend } from './Backend';
import {
  IStreamAssetCommitRequestV2,
  IStreamAssetRequestV2,
  IStreamAssetResponseV2,
  IStreamKeepAliveRequestV2,
  IStreamManifestResponseV3,
  IStreamStartRequestV2,
  IStreamStartResponseV2,
} from './models/AndromeTV.types';
import { QueryParam } from './models/Shared.types';

/**
 * StreamApi contains calls for handling streams
 */
export class StreamApi {
  /**
   * Request to start playing a stream
   */
  static start(backend: Backend, request: IStreamStartRequestV2): Promise<IStreamStartResponseV2> {
    const queryParam = {
      actionFilter: ottActionFilter,
    };
    const url = backend.makeUrl('stream/v2/stream', queryParam);
    return backend.postJson(url, request, backend.bearer) as Promise<IStreamStartResponseV2>;
  }

  /**
   * Start a reserved asset
   */
  static startReserved(
    backend: Backend,
    streamId: string,
    manifestId: string,
    request: IStreamAssetCommitRequestV2
  ): Promise<unknown> {
    const sid = encodeURIComponent(streamId);
    const mid = encodeURIComponent(manifestId);
    const url = backend.makeUrl(`stream/v2/stream/${sid}/asset/${mid}/commit`);
    return backend.putJson(url, request, backend.bearer);
  }

  static assetRequest(
    backend: Backend,
    streamId: string,
    request: IStreamAssetRequestV2,
    param: QueryParam // StreamParam?
  ): Promise<IStreamAssetResponseV2> {
    const sid = encodeURIComponent(streamId);
    const url = backend.makeUrl(`stream/v2/stream/${sid}/asset`, param);
    return backend.postJson(url, request, backend.bearer) as Promise<IStreamAssetResponseV2>;
  }

  /**
   * Stop the stream
   */
  static stop(backend: Backend, streamId: string) {
    const url = backend.makeUrl(`stream/v2/stream/${encodeURIComponent(streamId)}`);
    return backend.delete(url, backend.bearer);
  }

  /**
   * Retrieve the stream manifest for an asset
   */
  static manifest(backend: Backend, streamId: string, manifestId: string): Promise<IStreamManifestResponseV3> {
    const sid = encodeURIComponent(streamId);
    const mid = encodeURIComponent(manifestId);
    const url = backend.makeUrl(`stream/v3/stream/${sid}/asset/${mid}/manifest`);
    return backend.getJson(url, backend.bearer) as Promise<IStreamManifestResponseV3>;
  }

  /**
   * Send a keepalive for the stream
   */
  static keepalive(backend: Backend, streamId: string, data: IStreamKeepAliveRequestV2) {
    const url = backend.makeUrl(`stream/v2/stream/${encodeURIComponent(streamId)}/keepalive`);
    return backend.putJson(url, data, backend.bearer);
  }

  /**
   * Get an asset breakvertisement
   */
  static breakvertisement(
    backend: Backend,
    streamId: string,
    manifestId: string,
    param: QueryParam // streamparam?
  ) {
    const sid = encodeURIComponent(streamId);
    const mid = encodeURIComponent(manifestId);
    const url = backend.makeUrl(`stream/v2/stream/${sid}/asset/${mid}/break`, param);
    return backend.getJson(url, backend.bearer);
  }
}
